import React, { useEffect } from "react";
import "./style.scss";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import AppFooter from "../../components/AppFooter";
// import { isAndroid, isIOS } from "react-device-detect";
import { UAParser } from "ua-parser-js";
import { useSearchParams, useParams } from "react-router-dom";
// import usePixelFacebook from "../../Utils/Hooks/usePixelFacebook";

const Details = () => {
  // usePixelFacebook();
  const parser = new UAParser();
  // const device = parser.getDevice();
  const os = parser.getOS();
  const isAndroid = os.name === "Android";
  const isIOS = os.name === "iOS";
  const [searchParams] = useSearchParams();
  const permalinkSearchParams = searchParams.get("permalink");
  let { permalink } = useParams();
  if (!permalink && permalinkSearchParams) {
    permalink = permalinkSearchParams;
  }
  let mobileUrl = `mooshir-app://www.mooshir.com/details?permalink=${permalink}`;
  useEffect(() => {
    if (!permalink || !isAndroid || !isIOS) {
      window.location.replace("https://www.mooshir.com?download");
    }
    if (isAndroid) {
      // Modern browsers restrict navigation to custom schemes like intent:// unless initiated by a user gesture:
      /* <button onclick="redirectToApp()">Open App</button>
        <script>
          function redirectToApp() {
            const url = `intent://www.mooshir.com/details?permalink=${permalink}#Intent;scheme=mooshir-app;package=com.mooshir;end`;
            window.location.replace(url);
          }
        </script> */
      // mobileUrl = `intent://www.mooshir.com/details?permalink=${permalink}#Intent;scheme=mooshir-app;package=com.mooshir;end`;
      window.location.href = mobileUrl;
      const fallbackUrl =
        "https://play.google.com/store/apps/details?id=com.mooshir";
      // If the app isn't installed, fallback after delay
      setTimeout(() => {
        window.location.href = fallbackUrl;
      }, 10000);
    } else if (isIOS) {
      // TODO should check redirection on ios
      window.location.href = mobileUrl;
      const fallbackUrl =
        "https://apps.apple.com/app/mooshir-immobilier-services/id6453938369";
      // If the app isn't installed, fallback after delay
      setTimeout(() => {
        window.location.href = fallbackUrl;
      }, 10000);
    }
  }, [permalink]);

  return (
    <div className="details">
      <Navbar />
      <div className="details-text">
        <div>
          Si vous n’avez pas été redirigé automatiquement, veuillez cliquer sur
          le bouton:
        </div>
        {isAndroid ? (
          <>
            <a href="https://play.google.com/store/apps/details?id=com.mooshir">
              Télécharger l’application Mooshir
            </a>
          </>
        ) : isIOS ? (
          <a href="https://apps.apple.com/app/mooshir-immobilier-services/id6453938369">
            Télécharger l’application Mooshir
          </a>
        ) : (
          <>
            <a href="https://www.mooshir.com/?download">www.mooshir.com</a>
          </>
        )}
      </div>

      <div className="desk-footer">
        <Footer />
      </div>

      <div className="mobile-footer">
        <AppFooter containerColor="#EAF7FF" />
      </div>
    </div>
  );
};

export default Details;
